import { render, staticRenderFns } from "./CIndex.vue?vue&type=template&id=49b08518&"
import script from "./CIndex.ts?vue&type=script&lang=ts&"
export * from "./CIndex.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports